import React from 'react';

/**
 * Prevents a single uncaught render error anywhere in the tree from blanking the
 * entire page. Without this, e.g. passing a FastAPI validation-error array
 * (instead of a string) into a toast component throws "Objects are not valid
 * as a React child" and unmounts the whole app with no boundary to catch it.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled UI error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#F0F4F8] p-6">
          <div className="max-w-md w-full text-center bg-white rounded-xl border p-8 shadow-sm">
            <h1 className="text-xl font-semibold text-foreground mb-2">Something went wrong</h1>
            <p className="text-muted-foreground text-sm mb-6">
              This page hit an unexpected error. Try reloading — if it keeps happening, let us know what you were doing.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-[#003366] hover:bg-[#003366]/90 text-white px-6 py-2 rounded-lg text-sm font-medium"
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
